import { createContext, provide } from '@lit/context'
import { LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'

export interface LatLng {
  lat: string
  lon: string
}

export type GoogleMapsMapProviderActionsContextType = {
  setZoomLevel: (value: number) => void,
  setCenter: (value: LatLng) => void
}
export const GoogleMapsMapProviderZoomLevelContext = createContext(Symbol('google-maps-provider-zoom-level-context'))
export const GoogleMapsMapProviderCenterContext = createContext<LatLng>(Symbol('google-maps-provider-center-context'))
export const GoogleMapsMapProviderActionsContext = createContext<GoogleMapsMapProviderActionsContextType>(Symbol('google-maps-provider-action-context'))


@customElement('csc-google-maps-map-provider')
export class CSCGoogleMapsMapProvider extends LitElement {
  override renderRoot = this

  @provide({ context: GoogleMapsMapProviderZoomLevelContext })
  @property({ attribute: 'initial-zoom', reflect: true, type: Number })
  zoomLevel: number = 13

  @provide({ context: GoogleMapsMapProviderCenterContext })
  @property({ attribute: 'initial-center', type: Object, reflect: true })
  center!: LatLng

  @provide({ context: GoogleMapsMapProviderActionsContext })
  actions = {
    setZoomLevel: (zoom: number) => {
      this.zoomLevel = zoom
    },
    setCenter: (latLng: LatLng) => {
      this.center = latLng
    }
  }
}
